module.exports = __webpack_public_path__ + "static/img/info.504319db.svg";